import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuthSessionContext } from "../components/routing/auth-session-store";
import { hydrateSessionUser } from "../core/auth/auth";

export const Profile = () => {
	const { session } = useAuthSessionContext();
	const [isHydrating, setIsHydrating] = useState(false);

	useEffect(() => {
		let cancelled = false;
		if (!session?.user?.id) return;
		if (session.user.type_user) return;
		setIsHydrating(true);
		void hydrateSessionUser().finally(() => {
			if (!cancelled) setIsHydrating(false);
		});
		return () => {
			cancelled = true;
		};
	}, [session?.user?.id, session?.user?.type_user]);

	if (!session?.user?.id) {
		return <Navigate to='/login' replace />;
	}

	if (!session.user.type_user) {
		return (
			<div className='px-8 mt-8'>
				<div className='bg-white rounded-2xl border border-gray-100 shadow-sm p-6 text-gray-500'>
					{isHydrating ? "Cargando perfil..." : "Cargando perfil..."}
				</div>
			</div>
		);
	}

	if (session.user.type_user === "Proveedor") {
		return <Navigate to='/service/profile' replace />;
	}

	if (session.user.type_user === "Gerente") {
		// return <Navigate to='/user-profile' replace />;
		return <Navigate to='/admin/dashboard' replace />;
	}

	return <Navigate to='/user-profile' replace />;
};

